const NAV_GROUPS = [
  {
    label: "Overview",
    items: [
      { id: "introduction", label: "Introduction" },
      { id: "what-it-does", label: "What it can do" },
      { id: "tools", label: "Tools" },
      { id: "endpoint", label: "MCP endpoint" }
    ]
  },
  {
    label: "Connect",
    items: [
      { id: "connect", label: "How to connect" },
      { id: "other-ways", label: "Other clients" }
    ]
  },
  {
    label: "Using the MCP",
    items: [
      { id: "how-to-ask", label: "How to ask for data" },
      { id: "limitations", label: "Limitations" }
    ]
  },
  {
    label: "Security",
    items: [
      { id: "security", label: "Permissions" },
      { id: "security-tips", label: "Security tips" }
    ]
  },
  {
    label: "Changelog",
    items: [
      { id: "changelog", label: "v2.1 · Jul 28, 2026" },
      { id: "changelog-1-0", label: "v1.0 · Jul 1, 2026" }
    ]
  }
]

const Sidebar = ({ activeSection }) => (
  <nav className="mcp-doc-sidenav">
    {/* <div className="mcp-doc-nav-search">
      <svg width="14" height="14" viewBox="0 0 20 20" fill="currentColor">
        <path fillRule="evenodd" d="M8 4a4 4 0 100 8 4 4 0 000-8zM2 8a6 6 0 1110.89 3.476l4.817 4.817a1 1 0 01-1.414 1.414l-4.816-4.816A6 6 0 012 8z" clipRule="evenodd" />
      </svg>
      <span>Search</span>
      <kbd>⌘ K</kbd>
    </div> */}

    {NAV_GROUPS.map((group) => (
      <div key={group.label} className="mcp-doc-nav-group">
        <span className="mcp-doc-nav-group-label">{group.label}</span>
        {group.items.map((item) => (
          <a
            key={item.id}
            href={`#${item.id}`}
            className={`mcp-doc-nav-item${activeSection === item.id ? " active" : ""}`}
          >
            {item.label}
            {item.chevron && (
              <svg className="mcp-doc-nav-item-chevron" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M7.293 14.707a1 1 0 010-1.414L10.586 10 7.293 6.707a1 1 0 011.414-1.414l4 4a1 1 0 010 1.414l-4 4a1 1 0 01-1.414 0z"
                  clipRule="evenodd"
                />
              </svg>
            )}
          </a>
        ))}
      </div>
    ))}

    <div className="mcp-doc-nav-logo">
      <svg width="28" height="28" viewBox="0 0 40 40" fill="none">
        <path
          d="M24.8271 25.7389C23.4318 28.3136 19.7618 29.1034 17.2819 27.6712C16.4499 27.2184 15.7655 26.5392 15.3021 25.7125C15.26 25.6388 15.2389 25.5546 15.2284 25.4703C15.2231 25.3861 15.2284 25.3019 15.2547 25.2176C15.2811 25.1386 15.3232 25.0597 15.3758 24.9965C15.4337 24.9333 15.4969 24.8806 15.5759 24.8438C15.9182 24.6542 16.2077 24.8438 16.4921 25.0333L16.7343 25.1702C16.8133 25.2176 16.8975 25.2492 16.9765 25.2966C17.9242 25.8073 18.9878 26.0759 20.0672 26.0706C21.1466 26.0653 22.2049 25.7915 23.1527 25.2755C23.2317 25.2281 23.3001 25.1965 23.3791 25.1492C23.4581 25.1018 23.5265 25.0597 23.6108 25.0123C23.695 24.9649 23.8161 24.8859 23.9214 24.8174C24.0478 24.7437 24.1952 24.7174 24.3427 24.7385C24.4848 24.7595 24.6217 24.8227 24.7218 24.928C24.8218 25.0333 24.8902 25.165 24.9113 25.3071C24.9218 25.4598 24.8955 25.6072 24.8271 25.7389Z"
          fill="#2563eb"
        />
        <path
          d="M19.9893 36.4958C18.5993 36.4958 17.2145 36.0799 16.0298 35.2532L9.88519 30.9514C8.3951 29.9036 7.5 28.1924 7.5 26.3706V9.08987C7.5 7.72089 8.30033 6.45721 9.53767 5.87277C16.1878 2.71884 23.8119 2.71884 30.462 5.87277C31.6994 6.46248 32.4997 7.72615 32.4997 9.08987V26.3496C32.4997 28.1714 31.6099 29.8826 30.1145 30.9304L23.9488 35.2479C22.7641 36.0798 21.3741 36.4958 19.9893 36.4958ZM19.9998 6.29399C16.8407 6.29399 13.6762 6.99428 10.7329 8.38958C10.4644 8.51595 10.2906 8.78975 10.2906 9.08987V26.3706C10.2906 27.2815 10.7382 28.1398 11.4858 28.6663L17.6305 32.9681C19.0416 33.9579 20.9371 33.9579 22.3482 32.9681L28.5139 28.6505C29.2615 28.1292 29.7091 27.271 29.7091 26.3548V9.04248C29.6933 8.76342 29.5195 8.51069 29.2668 8.38958C26.3235 6.99428 23.159 6.29399 19.9998 6.29399Z"
          fill="#2563eb"
        />
      </svg>
      <span className="mcp-doc-nav-logo-name">Chargeback</span>
      <span className="mcp-doc-nav-logo-badge">MCP</span>
    </div>
  </nav>
)

export default Sidebar
